import { sessionConnector } from 'shared/connectors'
import { SESSION } from 'store/types'

const success = data => ({
  type: SESSION.GET_EVENTS_OPTIONS_SUCCESS,
  payload: {
    data,
  },
})

const failure = () => ({
  type: SESSION.GET_EVENTS_OPTIONS_FAILURE,
})

const getEventsOptions = () => async dispatch => {
  try {
    const { data } = await sessionConnector.getEventsOptions()
    dispatch(success(data))
  } catch (err) {
    dispatch(failure())
  }
}

export default getEventsOptions
